<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'sendTime')">
              <a-range-picker v-model='queryParam.sendTime' format='YYYY-MM-DD' style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item :label="'主产品'">
              <a-select mode='multiple' v-model='queryParam.mainSids' :max-tag-count="2">
                <a-select-option v-for='item in mainAppList' :key='item.appssid' :value='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item :label="'查询类型'">
              <a-select default-value="" style="width: 180px" v-model="queryParam.queryType">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="1">
                  主产品首贷申请数
                </a-select-option>
                <a-select-option value="2">
                  主产品复贷申请数
                </a-select-option>
                <a-select-option value="3">
                  子产品首贷申请数
                </a-select-option>
                <a-select-option value="4">
                  子产品复贷申请数
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'模型类型'">
              <a-select v-model='queryParam.remarks'>
                <a-select-option v-for='item in remarksList' :key='item.remarks' :value='item.remarks'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='12'>
          <a-col :span='6'>
            <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
            <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            <a-button type='primary' @click="downLoadData()" icon='download' style='margin-left: 8px'>{{ $t('exportFile') }}</a-button>
          </a-col>
        </a-row>
      </a-form>

      <!-- 汇总表格：保持不变 -->
      <a-card title="汇总数据" size="small" style="margin-bottom: 16px;">
        <a-table
          :columns="summaryColumns"
          :dataSource="summaryData"
          row-key="uid"
          :pagination="false"
          :show-header="true"
          size="small"
          bordered
        />
      </a-card>

      <!-- 【关键优化】：去掉了 .map，直接绑定 dataSource -->
      <a-table
        ref='table'
        row-key="index"
        size='middle'
        :columns='columns'
        :dataSource='dataSource' 
        :pagination='false'
        :loading='loading'
        bordered
      />
      
      <!-- <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div> -->
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { queryRiskScoreOrderInfo, queryRiskScoreSumOrderInfo, getApplistExcludingSubApp } from '@/webpublicapi/order'
import moment from 'moment'
import { exportFileByPost } from '@/api/exportFile'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}

export default {
  data() {
    return {
      I18N_KEY,
      mainAppList: [],
      remarksList: [],
      sum: {},
      form: { pageNum: 1, pageSize: 10 },
      total: 0,
      dataSource: [],
      queryParam: { tradeType: null, sendTime: [], mainSids: [], queryType: null },
      loading: false,
      queryTypeMap: {
        '': '申请数',
        '1': '主产品首贷申请数',
        '2': '主产品复贷申请数',
        '3': '子产品首贷申请数',
        '4': '子产品复贷申请数'
      }
    }
  },
  computed: {
    summaryColumns() {
      return [
        { key: 'applyOrderNumSum', title: '申请数-汇总', align: 'left', dataIndex: 'applyOrderNumSum' },
        { key: 'averageAmountSum', title: '件均额度-汇总', align: 'left', dataIndex: 'averageAmountSum' }, 
        { key: 'passOrderNumSum', title: '通过数-汇总', align: 'left', dataIndex: 'passOrderNumSum' },     
        { key: 'passRateSum', title: '通过率-汇总', align: 'left', dataIndex: 'passRateSum' }
      ]
    },
    summaryData() {
      const data = this.sum || {}
      return [
        {
          uid: 'SUMMARY_ROW_UNIQUE_KEY',
          applyOrderNumSum: this.formatNumber(data.applyOrderNum),
          passOrderNumSum: this.formatNumber(data.passOrderNum),
          averageAmountSum: this.formatNumber(data.averageAmount),
          passRateSum: data.passRate
        }
      ]
    },
    dynamicApplyTitle() {
      return this.queryTypeMap[this.queryParam.queryType] || '申请数'
    },
    columns() {
      return [
        { title: '日期', align: 'left', dataIndex: 'date' },
        { title: '盘号', align: 'left', dataIndex: 'appSsid' },
        { title: this.dynamicApplyTitle, align: 'left', dataIndex: 'applyOrderNum' },
        { title: '模型版本', align: 'left', dataIndex: 'modelVersion' },
        { title: '分数', align: 'left', dataIndex: 'modelScoreRange' },
        { title: '件均额度', align: 'left', dataIndex: 'averageAmount' },
        { title: '通过数', align: 'left', dataIndex: 'passOrderNum' },
        { title: '占比', align: 'left', dataIndex: 'applyOrderRate' },
        { title: '通过率', align: 'left', dataIndex: 'passRate' }
      ]
    }
  },
  created() {
    this.loadSelectData()
    this.loadData()
  },
  methods: {
    formatNumber(v) { return v == null ? 0 : Number(v).toLocaleString() },
    loadSelectData() {
      getApplistExcludingSubApp().then(res => res.data && (this.mainAppList = res.data))
    },
    searchQuery() { this.form.pageNum = 1; this.loadData() },
    loadData() {
      const p = this.getQueryParams()
      if (!p) return
      this.loading = true

      // 【关键优化 1】：使用 Promise.all 并行等待，并统一控制 loading 状态
      Promise.all([
        queryRiskScoreOrderInfo(p),
        queryRiskScoreSumOrderInfo(p)
      ]).then(([resList, resSum]) => {
        // 1. 处理主表格数据（直接在这里加 index，防止 template 中重复 map）
        if (resList.code === 1000) {
          const rows = resList.data.rows || []
          // 彻底卸载模板里的 .map，在赋值时一次搞定，极大节省重绘性能
          this.dataSource = rows.map((item, index) => ({ ...item, index }))
          this.total = resList.data.total || 0
        }

        // 2. 处理汇总数据
        if (resSum.code === 1000) {
          if (Array.isArray(resSum.data) && resSum.data.length > 0) {
            this.sum = resSum.data[0]
          } else {
            this.sum = {}
          }
        }
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        // 【关键优化 2】：等所有接口都回来再取消 loading，避免前端白屏等待
        this.loading = false
      })
    },
    transformTime: t => moment(t).format('YYYY-MM-DD'),
    getQueryParams() {
      const { sendTime } = this.queryParam
      const d = {
        ...this.queryParam,
        submitStartTime: sendTime?.length ? this.transformTime(sendTime[0]) : null,
        submitEndTime: sendTime?.length ? this.transformTime(sendTime[1]) : null,
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize
      }
      delete d.sendTime
      return filterObj(d)
    },
    async downLoadData() {
      const p = this.getQueryParams()
      delete p.pageNum; delete p.pageSize
      this.loading = true
      try { await exportFileByPost('/api/web/webpublic/platform/order/exportRiskScoreOrderInfo', p, '风控评分等级详情报表.xlsx') }
      catch (e) { this.$message.error(e.message) }
      finally { this.loading = false }
    },
    handleTableChange(pn, ps) { this.form.pageNum = pn; this.form.pageSize = ps; this.loadData() },
    searchReset() {
      this.queryParam = { tradeType: null, sendTime: [], mainSids: [], queryType: null }
      this.form = { pageNum: 1, pageSize: 10 }
      this.loadData()
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>